import { UnpackedGraph } from "@store/services/converter/types"
import JSZip from "jszip"

export async function graphConverterUnpackZip(blob: Blob): Promise<UnpackedGraph> {
  const zipData = await JSZip.loadAsync(blob)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const unpacked: any = { meta: undefined, xy: undefined, graph: undefined }
  for (const [key, value] of Object.entries(zipData.files)) {
    // skip as linked graphs are written into sub-folders
    if (key.includes("/")) continue
    if (key.endsWith(".meta")) {
      unpacked.meta = JSON.parse(await value.async("string"))
      if (unpacked.meta) {
        unpacked.meta.fileName = key.split(".meta")[0]
      }
    } else if (key.endsWith(".xy")) {
      unpacked.xy = JSON.parse(await value.async("string"))
    } else if (key.endsWith(".json")) {
      unpacked.graph = JSON.parse(await value.async("string"))
    } else if (key.endsWith(".scenario")) {
      unpacked.scenario = await value.async("string")
    }
  }
  return unpacked
}
